<template>
  <div class="list-wrap">
    <div v-if="resultList.list && resultList.list.length>0">
      <div class="list-item-wrap"
           v-for="item in resultList.list"
           :key="item.id"
           @click="toDetail(item)">
        <div class="fText single-omit">{{ item.title }}</div>
        <div class="time">{{ item.publishTime }}</div>
      </div>
      <div class="list-more"><span @click="toMore">更多></span></div>
    </div>
    <div class="noData"
         v-else>
      <img src="../../../../public/static/nodata.png"
           alt="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    resultList: Object,
    name: String
  },
  data() {
    return {
      selectedId: ''
    }
  },
  components: {},
  computed: {
    ...mapGetters('headerMenu', ['setUpdateMenuList']),
    menuList() {
      return this.setUpdateMenuList
    }
  },
  methods: {
    toDetail(val) {
      this.$emit('handleDetail', val)
    },
    toMore() {
      if (this.name === '政策法规') {
        this.$router.push({
          path: '/informationService',
          query: {
            code: 'zydh',
            selectedId: this.commonHandle('zydh', 'policiesRegulations')
          }
        })
      } else {
        this.$router.push({
          path: '/informationService',
          query: {
            code: 'zydh',
            selectedId: this.commonHandle('zydh', 'newsExpress')
          }
        })
      }
    },
    commonHandle(codeOne, codeTwo) {
      let obj = this.menuList.filter((res) => res.code === codeOne)
      let selectedId
      obj[0].children.forEach((res) => {
        if (res.code === codeTwo) {
          selectedId = res.id
        }
      })
      return selectedId
    }
  }
}
</script>
